import { render, staticRenderFns } from "./SpaceView.vue?vue&type=template&id=cd1f0c56&"
import script from "./SpaceView.vue?vue&type=script&lang=js&"
export * from "./SpaceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports